import { createContext } from 'react';
import { DataRoomNda } from '../../models/DataRoomNDA';

type DataRoomNdaContextProps = {
  dataRoomNdas: DataRoomNda[];
  isLoading: boolean;
};

export default createContext<Partial<DataRoomNdaContextProps>>({
  dataRoomNdas: [],
  isLoading: true,
});
